import React from 'react';
import { connect } from 'react-redux';

import { closeSystemNotification } from '../../../store/notifications/actions';
import ErrorDialog from './ErrorDialog';

function System (props) {
    const { open } = props.systemNotification;

    return (
        <ErrorDialog
            title="System Error"
            subtitle="A system error has occurred"
            handleClose={props.closeDialog}
            open={open}
            helpText="Please try again."
        />
    );
}

const mapStateToProps = state => ({
    systemNotification: state.notifications.system
});

const mapDispatchToProps = dispatch => ({
    closeDialog: () => dispatch(closeSystemNotification())
});

export default connect(mapStateToProps, mapDispatchToProps)(System);
